// ============================================================
// COMPANY DOMAINS — har company apne alag domain par deploy hogi.
// Jab domain live ho jaye, yahan URL dal den (e.g. "https://digitalsystems.com").
// null = abhi deploy nahi hui → main site ke andar preview page khulta hai.
// ============================================================

export const companyDomains: Record<string, string | null> = {
  "digital-systems": "https://digital-systems.tech",
  "appforge": "https://appforge.com.co",
  "venture-xcelerator": "https://venturesxcelerator.co",
  "epitech": null, // domain abhi nahi mila — internal preview
  "the-founders-tx": "https://foundertx.com",
  "commerce-x": "https://commercex.us",
  "growth-iq": "https://growthiq.com.co",
  "visual-systems": "https://visualsystems.tech",
  "platform-systems": "https://platformsystems.us",
  "flawless-x": "https://flawlessx.co",
};

/** Company ka nav link — domain set ho to external URL, warna internal preview */
export const companyLink = (slug: string): string =>
  companyDomains[slug] ?? `/companies/${slug}`;

export const isExternal = (link: string): boolean => link.startsWith("http");
